import request from './common/request'
import { SIMBART_MERCHANT_RANKING_BOARD_URL } from './urls'

// 榜单分页列表
async function list(query) {
  return request({
    url: SIMBART_MERCHANT_RANKING_BOARD_URL,
    method: 'GET',
    params: query
  })
}

// 创建榜单
async function create(data) {
  return request({
    url: SIMBART_MERCHANT_RANKING_BOARD_URL,
    method: 'POST',
    data
  })
}

// 更新榜单
async function update(data) {
  return request({
    url: `${SIMBART_MERCHANT_RANKING_BOARD_URL}/${data.id}`,
    method: 'PUT',
    data
  })
}

// 更新榜单状态（启用/停用）
async function changeStatus({ id, status }) {
  return request({
    url: `${SIMBART_MERCHANT_RANKING_BOARD_URL}/${id}/status`,
    method: 'PUT',
    params: { status }
  })
}

// 删除榜单
async function remove(id) {
  return request({
    url: `${SIMBART_MERCHANT_RANKING_BOARD_URL}/${id}`,
    method: 'DELETE'
  })
}

// 可选榜单列表（同类型）
async function selectable(query) {
  return request({
    url: `${SIMBART_MERCHANT_RANKING_BOARD_URL}/selectable`,
    method: 'GET',
    params: query
  })
}

// 校验报名是否可写入榜单（路径 rankingId 为目标榜单 ID）
async function validateEntries({ rankingId, entryValueIds }) {
  return request({
    url: `${SIMBART_MERCHANT_RANKING_BOARD_URL}/${rankingId}/entries/validate`,
    method: 'POST',
    data: { entryValueIds }
  })
}

// 榜单关联报名分页
async function listEntries(params) {
  const { rankingId, ...query } = params
  return request({
    url: `${SIMBART_MERCHANT_RANKING_BOARD_URL}/${rankingId}/entries`,
    method: 'GET',
    params: query
  })
}

// 榜单关联行批量显示/隐藏（ids 为关联行主键 tbl_simbart_ranking_board_entry.id）
async function batchHiddenEntries({ rankingId, ids, hidden }) {
  return request({
    url: `${SIMBART_MERCHANT_RANKING_BOARD_URL}/${rankingId}/entries/batchHidden`,
    method: 'PUT',
    data: { ids, hidden }
  })
}

// 榜单关联行批量逻辑删除（ids 为关联行主键，与 batchHidden 一致）
async function batchDeleteEntries({ rankingId, ids }) {
  return request({
    url: `${SIMBART_MERCHANT_RANKING_BOARD_URL}/${rankingId}/entries/batchDelete`,
    method: 'POST',
    data: { ids }
  })
}

// 从活动批量将报名写入榜单（rankingId 为目标榜单）
async function addEntriesFromActivity({ rankingId, entryValueIds }) {
  return request({
    url: `${SIMBART_MERCHANT_RANKING_BOARD_URL}/${rankingId}/entries/fromActivity`,
    method: 'POST',
    data: { entryValueIds }
  })
}

// 从其他榜单叠加快照（按选中报名）；rankingId 为目标榜单
async function stackFromRanking({
  rankingId,
  sourceRankingId,
  sourceEntryValueIds,
  inheritOnNew,
  accumulateOnDuplicate
}) {
  const data = {
    sourceRankingId,
    sourceEntryValueIds
  }
  if (inheritOnNew !== undefined) data.inheritOnNew = inheritOnNew
  if (accumulateOnDuplicate !== undefined) data.accumulateOnDuplicate = accumulateOnDuplicate
  return request({
    url: `${SIMBART_MERCHANT_RANKING_BOARD_URL}/${rankingId}/stackFromRanking`,
    method: 'POST',
    data
  })
}

export default {
  list,
  create,
  update,
  changeStatus,
  remove,
  selectable,
  validateEntries,
  listEntries,
  batchHiddenEntries,
  batchDeleteEntries,
  addEntriesFromActivity,
  stackFromRanking
}




// WEBPACK FOOTER //
// ./src/api/merchant-simbart-ranking-board.js